<div mat-dialog-title class="title-modal-calendar">
  <h1> Visualização de relatório por data </h1>
  <span (click)="close()">X</span>
</div>

<div class="custom-mat-divider-modal-calendar">
  <mat-divider></mat-divider>
</div>

<div mat-dialog-content class="content-modal-calendar">
  <div class="select-period-modal-calendar">
    <strong>Período:</strong>
  </div>
  <nz-range-picker 
    [(ngModel)]="date" 
    class="datepicker-range"
    (ngModelChange)="onChange($event)"
    [nzFormat]="'dd MMM yyyy'">
  </nz-range-picker>
</div>

<div class="custom-mat-divider-modal-calendar">
  <mat-divider></mat-divider>
</div>

<div class="action-modal-calendar">
  <lib-button-secondary class="btn-action-modal-calendar" (click)="close()">Cancelar</lib-button-secondary>
  <lib-button-primary (click)="download()" [isDisabled]="form.invalid" *ngIf="!loading">Fazer Download</lib-button-primary>
  <mat-spinner *ngIf="loading" [diameter]="40" class="custom-spinner"></mat-spinner>
</div>